import { useSelector, useDispatch } from "react-redux";
import { setTheme } from "../state-management/actions/global-state-actions";
import theme from "../config/theme";

const ToggleChangeTheme = ({ lightIcon, darkIcon }) => {
  const { theme: themeMode } = useSelector((state) => state.globalState);
  const mode = themeMode === "light" ? theme.light : theme.dark;
  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(setTheme(themeMode === "light" ? "dark" : "light"));
  };

  return (
    <label className="relative inline-block w-10 h-7">
      <input
        type="checkbox"
        className="opacity-0 w-0 h-0 peer"
        checked={themeMode === "dark" ? true : false}
        onChange={handleToggle}
      />
      <span
       className={`absolute cursor-pointer top-0 left-0 right-0 bottom-0 transition-all duration-500 rounded-full`}
        style={{ backgroundColor: mode.color.textPrimary }}
      />
      {themeMode === "light" ? lightIcon : darkIcon}
    </label>
  );
};

export default ToggleChangeTheme;